import React, { useState, useEffect, useRef } from "react";
import MDBox from "components/MDBox";
import Grid from "@mui/material/Grid";
import { Box, Button, Card, CardContent, CircularProgress, Icon } from "@mui/material";
import CTLBaseForm from "../CTLBaseForm";
import { agentAttributes, agentOperationURLS } from "./AgentForm/model";
import { application } from "globals/endpoints";
import ChatWindow from "./ChatBox/chatWindow";
import ManualDailingBox from "./manualDailingBox";
import CTLAgentMessageSend from "../CTLAgentMessageSend";
import { useMaterialUIController, setAgentData } from "context";
import CTLNotification from "application/components/CTLNotification";
import { setAgentStatusData } from "context";
import loggerFactory from "globals/logger/logger-factory";
import AuthenticationService from "application/modules/authentication/AuthenticationService";
import { setOpenPopup } from "context";
import { setCallType } from "context";
import { setFormSave } from "context";
import { setAgentCallBackData } from "context";
import SendSMSDialog from "./sendSMS";
import SendEmailDialog from "./sendEmail";
import dayjs from "dayjs";
import MDTypography from "components/MDTypography";
import callImage from "assets/images/customer-service.png";
import { Padding } from "@mui/icons-material";
export default function CTLAgentDashboard({
  onLoad,
  registerCallBacks,
  pageName,
}) {
  const componentName = "Agent From Data";
  const [controller, dispatch] = useMaterialUIController();
  const [responseData, setResponseData] = useState(null);
  const [openMessageForm, setOpenMessageForm] = useState(false);
  const [openChat, setOpenChat] = useState(false);
  const [checkSaveForm, setCheckSaveForm] = useState(false);
  const [Status, setUserStatus] = useState("");
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });
  const buttonClick = useRef("");
  const { activePage, callType, openPopup, formSave } = controller;
  const [openSMSDialog, setOpenSMSDialog] = useState(false);
  const [openEmailDialog, setOpenEmailDialog] = useState(false);
  const [loading, setLoading] = useState(false);

  const [agentStatus, setAgentStatus] = useState({});
  const [queueStatus, setQueueStatus] = useState({});
  useEffect(() => {
    agentAttributes && onLoad(agentAttributes);
    registerCallBacks({
      onChat: onChat,
      onSendSMS: onSendSMS,
      onSendEmail: onSendEmail,
    });
  }, [activePage]);

  const onSendSMS = () => {
    setOpenSMSDialog(true);
  };

  const onSendEmail = () => {
    setOpenEmailDialog(true);
  };

  const handleCloseSMSDialog = () => {
    setOpenSMSDialog(false);
  };

  const handleCloseEmailDialog = () => {
    setOpenEmailDialog(false);
  };

  const getAgentStatus = () => {
    const fullName = AuthenticationService.getUserName();
    application
      .post(`/agent/${fullName}`)
      .then((response) => {
        const data = response.data.data;
        setAgentStatusData(dispatch, data);
        setAgentStatus(data);
      })
      .catch((error) => {
        loggerFactory.debug("Error: Unable to get agent status ", error);
        setAgentStatusData(dispatch, {});
        setAgentStatus({});
      });

      application
      .post(`/tiers/getCount`)
      .then((response) => {
        const data = response?.data?.data;
        setAgentStatusData(dispatch, data);
        setQueueStatus(data);
      })
      .catch((error) => {
        loggerFactory.debug("Error: Unable to get Queue status ", error);
        setAgentStatusData(dispatch, {});
        setQueueStatus({});
      });

    const payload = {
      currentPage: 0,
      pageSize: 10,
      sortDirection: "desc",
      sortBy: "callerId",
      search: "",
      sortDataType: "integer",
      advancedFilters: [],
    };
    application
      .post("/callbackReport/list", payload)
      .then((response) => {
        setAgentCallBackData(dispatch, response.data.data.totalRecords);
      })
      .catch((error) => {
        loggerFactory.debug("Error: Unable to get agent status ", error);
        setAgentCallBackData(dispatch, "");
      });
  };

  function handleLoadForm(callType, number) {
    const body = {
      callType: callType,
      phoneNumber: number,
    };
    application
      .post("/leadUpload/update", body)
      .then((response) => {
        setResponseData(response.data.data);
        setAgentData(dispatch, response.data.data);
        loggerFactory.debug(
          componentName,
          "Agent From Data : ",
          response.data.data
        );
      })
      .catch((error) => {
        loggerFactory.debug(
          componentName,
          " unable to get agent from data : ",
          error
        );
      });
  }

  useEffect(() => {
    const interval = setInterval(() => {
      getAgentStatus();
    }, 10000);
    getAgentStatus();
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (openPopup) {
      handleLoadForm(callType, openPopup);
    }
  }, []);


useEffect(() => {
  
  const cleanNumber = (num) => {
    if (!num) return "";
    return num.toString().trim().replace(/\s+/g, "");
  };

  // Received Event Data
  const handleMessage = (event) => {
    console.log(" event received:", event);

    if (event?.data?.eventType === "incomingCallData") {
      const number = cleanNumber(event?.data?.data?.number);
      console.log("Incoming Call event received:", number);

      setOpenPopup(dispatch, number);
      setCallType(dispatch, "");
      setFormSave(dispatch, false);
      handleLoadForm("", number);
    } else if (event?.data?.eventType === "dialCallData") {
      const number = cleanNumber(event?.data?.data?.number);
      console.log("Dial Call event received :", number);

      setFormSave(dispatch, false);
      setCallType(dispatch, "dial");
      handleLoadForm("dial", number);
      setOpenPopup(dispatch, number);
    } else if (event?.data?.eventType === "disconnectCallData") {
      console.log("disconnect Call event received ");
      setFormSave(dispatch, true);
    }
  };

  window.addEventListener("message", handleMessage);

  return () => {
    window.removeEventListener("message", handleMessage);
  };
}, [activePage]);


  const handleSend = (messageType) => {
    setOpenMessageForm(true);
    buttonClick.current = messageType;
  };

  const onChat = () => {
    setOpenChat(true);
  };

  const onCloseChat = () => {
    setOpenChat(false);
  };

  const isValidFutureDateTime = (dateTimeString) => {
    const parsedDate = dayjs(dateTimeString);
    return parsedDate.isValid() && parsedDate.isAfter(dayjs());
  };

  function saveForm(data) {
    if (!formSave) {
      setNotify({
        isOpen: true,
        type: "error",
        pagename: pageName,
        message: "error",
        status: " Please disconnect call to save data",
      });
      return;
    }

    if (
      data.disposition === "" ||
      data.disposition === null ||
      data.disposition == undefined
    ) {
      setNotify({
        isOpen: true,
        type: "warning",
        pagename: pageName,
        message: "Warning",
        status: "Please select disposition to save data",
      });
      return;
    }

    if (
      data.disposition === "CALLBACK" ||
      data.disposition === "DND" ||
      data.disposition === "DENY"
    ) {
      if (
        !data.recordLastModifiedOn ||
        data.recordLastModifiedOn === null ||
        data.recordLastModifiedOn === ""
      ) {
        setNotify({
          isOpen: true,
          type: "warning",
          pagename: pageName,
          message: "Warning",
          status: "Please select Date and Time",
        });
        return;
      } else if (!isValidFutureDateTime(data.recordLastModifiedOn)) {
        setNotify({
          isOpen: true,
          type: "warning",
          pagename: pageName,
          message: "Warning",
          status: "Please select a future Call Back Date and Time",
        });
        return;
      }
    }
    setLoading(true); 
    const customerData = {
      dialId: responseData.dialId,
      phoneNumber: responseData.formData.phoneNumber,
      formType: responseData.formType,
      sessionUuid: responseData.agentInfo.sessionUuid,
      uuid: responseData.agentInfo.uuid,
      valueType: responseData.formData.valueType,
      queueName: responseData.agentInfo.queueSystemName,
      campaignId: responseData.campaignId,
    };

    let formData = data;
    let customerInfoData = customerData;

    let APIData = { formData, customerInfoData };

    application
      .post(agentOperationURLS.create, APIData)
      .then((response) => {
        setNotify({
          isOpen: true,
          type: "success",
          pagename: pageName,
          status: response.data.message,
        });
        setResponseData(null);
        setAgentData(dispatch, "");
        setOpenPopup(dispatch, "");
        setCallType(dispatch, "");

        if (window.disablePhone) {
          const eventData = {
            eventType: "disposition form save",
            data: "",
          };
          window?.chrome?.webview?.postMessage(JSON.stringify(eventData));
          console.log("Form Submit Event:", eventData);
        } else {
          const payload = { status: "Start Call" };
          if (
            Status != "On Break" &&
            Status != "Available for manual" &&
            Status != "Available (On Demand) for manual"
          ) {
            application.post("/agentStatus/create", payload);
          }
        }
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          message: error?.response?.data?.message,
          type: "error",
          pagename: pageName,
        });
      }).finally(() => {
        setLoading(false); 
      });
  }

  useEffect(() => {
    if (responseData) {
      if (responseData.dispositionUrl !== "") {
        window.open(responseData.dispositionUrl, "_blank");
      }
    }
  }, [responseData]);

  const cardConfig = {
    // "Call In Queue": { icon: "queue", color: "warning.main" },
    "Calls In Queue": {
      icon: "call_missed",
      color: "warning.main",
      key: "count",
    },
    "Answer Calls": {
      icon: "call",
      color: "success.main",
      key: "totalAnswered",
    },
    "Missed Calls": {
      icon: "call_missed",
      color: "error.main",
      key: "totalNoAnswered",
    },
    "Received Calls": {
      icon: "call_received",
      color: "#9e9d24",
      key: "totalOffered",
    },
    "Dial Calls": { icon: "call_made", color: "info.main", key: "totalDialed" },
    // "Avg Calls Duration": { icon: "schedule", color: "secondary.main" },
  };
  const cards = Object.keys(cardConfig);

  return (
    <>
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(9, 9, 12, 0.4)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <CircularProgress color="info" />
          <MDTypography variant="h6" sx={{ mt: 2 }}>
            Saving, please wait…
          </MDTypography>
        </Box>
      )}

      <Grid container spacing={1} mb={1}>
        {cards.map((title, index) => {
          const { icon, color, key } = cardConfig[title] || {};
          return (
            <Grid item xs={2.4} key={index}>
              <Card
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  p: 1,
                  m: 0,
                  bgcolor: `${color}20`,
                }}
              >
                <CardContent
                  sx={{
                    textAlign: "center",
                    p: 0,
                    m: 0,
                    "&:last-child": { paddingBottom: 0 },
                  }}
                >
                  <MDTypography
                    variant="caption1"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color,
                      p: 0,
                      m: 0,
                    }}
                  >
                    <Icon sx={{ mr: 0.5, fontSize: 20 }}>{icon}</Icon>
                    {title} : {(agentStatus[key] || 0) + (queueStatus[key] || 0) }
                  </MDTypography>
                  {/* <MDTypography
                    variant="caption"
                    sx={{
                      color,
                      p: 0,
                      m: 0,
                    }}
                  >
                    {0}
                  </MDTypography> */}
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      <Grid container spacing={1}>
        {!window?.disablePhone ? (
          <>
            <Grid item xs={10}>
              <Card
                style={{
                  minHeight: "calc(100vh - 150px)",
                }}
              >
                {responseData ? (
                  <MDBox
                    style={{
                      maxHeight: "calc(100vh - 150px)",
                      overflow: "auto",
                      position: "relative",
                    }}
                  >
                    {responseData.dispositionUrl == "" && (
                      <CTLBaseForm
                        enableAgentFormButtons={true}
                        handleSend={handleSend}
                        entityName="Agent"
                        columns={responseData.form}
                        openForm={true}
                        onSaveForm={saveForm}
                        onCloseForm={null}
                        formData={responseData.formData}
                        formAttributes={agentAttributes}
                      />
                    )}
                  </MDBox>
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ height: "89vh" }}
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      sx={{ width: "100%" }}
                    >
                      <img src={callImage} alt="callImage" height={100} />
                    </Box>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      paddingTop={5}
                    >
                      <MDTypography variant="h5">
                        No Active Call...
                      </MDTypography>
                    </Box>
                  </Box>
                )}
              </Card>
            </Grid>
            <Grid item xs={2}>
              <Card
                style={{
                  minHeight: "calc(100vh - 150px)",
                }}
              >
                <MDBox
                  style={{
                    maxHeight: "calc(100vh - 150px)",
                    overflow: "auto",
                    position: "relative",
                  }}
                >
                  <ManualDailingBox
                    setResponseData={setResponseData}
                    setCheckSaveForm={setCheckSaveForm}
                    setUserStatus={setUserStatus}
                    activePage={activePage}
                  />
                </MDBox>
              </Card>
            </Grid>
          </>
        ) : (
          <Grid item xs={12}>
            <Card
              style={{
                minHeight: "calc(100vh - 150px)",
              }}
            >
              {responseData ? (
                <MDBox
                  style={{
                    maxHeight: "calc(100vh - 150px)",
                    overflow: "auto",
                    position: "relative",
                  }}
                >
                  {responseData.dispositionUrl == "" && (
                    <CTLBaseForm
                      enableAgentFormButtons={true}
                      handleSend={handleSend}
                      entityName="Agent"
                      columns={responseData.form}
                      openForm={true}
                      onSaveForm={saveForm}
                      onCloseForm={null}
                      formData={responseData.formData}
                      formAttributes={agentAttributes}
                    />
                  )}
                </MDBox>
              ) : (
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ height: "89vh" }}
                >
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ width: "100%" }}
                  >
                    <img src={callImage} alt="callImage" height={100} />
                  </Box>
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    paddingTop={5}
                  >
                    <MDTypography variant="h5">No Active Call...</MDTypography>
                  </Box>
                </Box>
              )}
            </Card>
          </Grid>
        )}
      </Grid>
      <ChatWindow openChat={openChat} onCloseChat={onCloseChat} />
      <CTLAgentMessageSend
        onSendClick={""}
        onSendMessage={openMessageForm}
        onCloseMessageBox={() => setOpenMessageForm(false)}
        buttonClick={buttonClick.current}
      />
      <SendSMSDialog open={openSMSDialog} onClose={handleCloseSMSDialog} />
      <SendEmailDialog
        open={openEmailDialog}
        onClose={handleCloseEmailDialog}
      />
      <CTLNotification notify={notify} setNotify={setNotify} />
    </>
  );
}
